import { useTheme } from "next-themes";
import { CheckCircle2, CircleAlert, CircleX, Info, Loader2 } from "lucide-react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-right"
      visibleToasts={4}
      duration={4000}
      gap={8}
      closeButton
      offset={16}
      mobileOffset={16}
      icons={{
        success: <CheckCircle2 className="h-4 w-4 text-emerald-600" aria-hidden="true" />,
        info: <Info className="h-4 w-4 text-foreground" aria-hidden="true" />,
        warning: <CircleAlert className="h-4 w-4 text-amber-600" aria-hidden="true" />,
        error: <CircleX className="h-4 w-4 text-destructive" aria-hidden="true" />,
        loading: <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" aria-hidden="true" />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast !gap-3 !rounded-lg !border !border-border !bg-card !p-4 !text-foreground !shadow-lg",
          title: "!text-sm !font-medium !leading-5",
          description: "!text-xs !leading-5 !text-muted-foreground",
          icon: "!m-0 !self-start !pt-0.5",
          closeButton:
            "!border-border !bg-card !text-muted-foreground hover:!bg-muted hover:!text-foreground",
          actionButton:
            "!h-8 !rounded-md !bg-primary !px-3 !text-xs !font-medium !text-primary-foreground hover:!bg-primary/90",
          cancelButton:
            "!h-8 !rounded-md !bg-muted !px-3 !text-xs !font-medium !text-foreground hover:!bg-muted/80",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
